// bbox query helpers shared by the trail + water maps.

// "minLat=…&minLon=…&maxLat=…&maxLon=…" for a Leaflet LatLngBounds.
export function boundsParams(bounds) {
  return new URLSearchParams({
    minLat: bounds.getSouth(), minLon: bounds.getWest(),
    maxLat: bounds.getNorth(), maxLon: bounds.getEast()
  }).toString()
}

// Same, from a map's current view.
export function bboxParams(map) {
  return boundsParams(map.getBounds())
}

// True when the bounds span more than maxDegrees in lat or lon — used to gate
// zoom-limited upstream layers (rivers/lakes/forest trails/etc.).
export function boundsTooBig(bounds, maxDegrees) {
  return (bounds.getNorth() - bounds.getSouth()) > maxDegrees ||
         (bounds.getEast() - bounds.getWest()) > maxDegrees
}
